"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MakeFlagIconOptionsPropType = exports.MakeFlagIconPropsType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _props = require("../functions/props");

var _propTypes2 = require("../functions/propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FlagIconSizeType = _propTypes.default.oneOf((0, _props.getSizes)());

var FlagIconRotateType = _propTypes.default.oneOf((0, _props.getRotates)());

var FlagIconFlipType = _propTypes.default.oneOf((0, _props.getFlips)());

var makeFlagIconCodeType = function makeFlagIconCodeType(codes) {
  return _propTypes.default.oneOf(codes);
};

var makeFlagIconClassesObject = function makeFlagIconClassesObject(codes) {
  return {
    code: makeFlagIconCodeType(codes).isRequired,
    size: FlagIconSizeType,
    squared: _propTypes.default.bool,
    rotate: FlagIconRotateType,
    flip: FlagIconFlipType,
    className: _propTypes.default.string,
    styleName: _propTypes.default.string
  };
};

var makeFlagIconPropsTypeObject = function makeFlagIconPropsTypeObject(codes) {
  return _objectSpread({}, makeFlagIconClassesObject(codes), {
    children: _propTypes.default.element,
    Component: _propTypes.default.string
  });
};

var MakeFlagIconPropsType = function MakeFlagIconPropsType(codes) {
  return (0, _propTypes2.AddNoExtraPropsValidator)(makeFlagIconPropsTypeObject(codes));
};

exports.MakeFlagIconPropsType = MakeFlagIconPropsType;
var flagIconOptionsType = {
  customCodes: _propTypes.default.object,
  themeStyles: _propTypes.default.object,
  useCssModules: _propTypes.default.bool
};

var MakeFlagIconOptionsPropType = function MakeFlagIconOptionsPropType() {
  return (0, _propTypes2.AddNoExtraPropsValidator)((0, _propTypes2.AddThemeStylesValidator)(flagIconOptionsType));
};

exports.MakeFlagIconOptionsPropType = MakeFlagIconOptionsPropType;


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/types/propTypes.js
// module id = 143
// module chunks = 168707334958949